import React from 'react';
export interface HeroBannerProps {
  title: string;
  subtitle?: string;
}
export function HeroBanner({
  title,
  subtitle
}: HeroBannerProps) {
  return <section className="relative bg-[#0c2340] py-20 sm:py-28 overflow-hidden border-t border-white/10" data-id="element-143" data-mp="3e97pyroiv6cb">
      {/* Subtle background pattern/texture */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }} aria-hidden="true" data-id="element-144" data-mp="3o5194twqxy32" />

      {/* Gradient overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#0a1c33]/80" aria-hidden="true" data-id="element-145" data-mp="fofx148tiovq" />

      <div className="relative max-w-7xl mx-auto px-4 text-center" data-id="element-146" data-mp="ar69ju4zonaj">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white tracking-tight mb-4" data-id="element-147" data-mp="or7blcwzq0rl">
          {title}
        </h1>
        {subtitle && <p className="text-lg sm:text-xl text-slate-300 max-w-2xl mx-auto mb-8" data-id="element-148" data-mp="2gyj0u9irn4mu">
            {subtitle}
          </p>}
        <div className="w-24 h-1 bg-[#b87333] mx-auto rounded-full" aria-hidden="true" data-id="element-149" data-mp="2lwswsmcbe99i" />
      </div>
    </section>;
}